import { useLocation } from "react-router-dom";

import { translations, Translation } from "./translations";

export type Lang = "de" | "en";

export const LANG_STORAGE_KEY = "rocknitive-lang";

export const langFromPathname = (pathname: string): Lang =>
  pathname === "/en" || pathname.startsWith("/en/") ? "en" : "de";

/** Strips the /en prefix so both language trees resolve to the same base route. */
export const basePathname = (pathname: string): string => {
  if (pathname === "/en") return "/";
  if (pathname.startsWith("/en/")) return pathname.slice(3);
  return pathname;
};

/** Builds the route for a base path (e.g. "/imprint") in the given language. */
export const langPath = (base: string, lang: Lang): string => {
  if (lang === "de") return base;
  return base === "/" ? "/en" : `/en${base}`;
};

export const useLang = (): Lang => {
  const { pathname } = useLocation();
  return langFromPathname(pathname);
};

export const useTranslation = (): Translation => translations[useLang()];

export { translations };
export type { Translation };
